import { render, staticRenderFns } from "./TrainingMiniatureChart.vue?vue&type=template&id=98b87634&"
import script from "./TrainingMiniatureChart.vue?vue&type=script&lang=js&"
export * from "./TrainingMiniatureChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports